export default {"src":"/_next/static/media/apk-qr-primexbt-ch.6aa5bb8f.svg","height":225,"width":225,"blurWidth":0,"blurHeight":0};